import {
  DestroyRef,
  effect,
  inject,
  type Signal,
  type TemplateRef,
} from '@angular/core';
import { CabinetPageLayoutService } from '@nebalkon-workspace/cabinet-client';

/** Pushes a header action template (e.g. add button) into `CabinetClientPageComponent` chrome. */
export function bindStaffPageHeaderAction(
  embeddedInCabinetPage: Signal<boolean>,
  headerActionTpl: Signal<TemplateRef<unknown> | undefined>,
  visible: Signal<boolean>,
): void {
  const layout = inject(CabinetPageLayoutService, { optional: true });
  const destroyRef = inject(DestroyRef);

  effect(() => {
    if (!embeddedInCabinetPage() || !layout) {
      return;
    }

    const template = visible() ? headerActionTpl() : undefined;
    layout.setHeaderAction(template ?? null);
  });

  destroyRef.onDestroy(() => {
    layout?.setHeaderAction(null);
  });
}
